<button matIconButton
  class="full-page-dialog-header__close-btn"
  [attr.aria-label]="closeAriaLabel"
  (click)="closed.emit()">
  <mat-icon>{{ leadingIcon }}</mat-icon>
</button>
<div class="full-page-dialog-header__titles">
  <h3 [id]="ariaId"
    class="full-page-dialog-header__title"
    tabindex="-1">{{ title }}</h3>
  @if (subtitle) {
    <p class="full-page-dialog-header__subtitle">{{ subtitle }}</p>
  }
</div>
<div class="full-page-dialog-header__action">
  <ng-content select="[fullPageDialogAction]"></ng-content>
</div>
